<template>
    <div class="confirm-dialog-help modal fade" tabindex="-1" role="dialog" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header bg-primary text-white align-items-center">
                    <h5 class="help-title">{{ $t("dialogs.help.title") }}</h5>
                    
                    <div class="d-flex align-items-center">
                        <div class="mr-4">
                            <button type="button" class="btn btn-primary btn-sm" v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang.code)">
                                <span aria-hidden="true">{{ lang.code }}</span>
                            </button>
                        </div>
                        
                        <button v-if="video" type="button" class="btn btn-primary" @click="shownVideo = !shownVideo">
                            <span aria-hidden="true"><i class="fa" :class="shownVideo ? 'fa-video' : 'fa-font'"></i></span>
                        </button>
                        
                        <button v-if="isAdmin" type="button" class="btn btn-primary" aria-label="Edit" @click="openEditHelpDialog()">
                            <span aria-hidden="true"><i class="fa fa-edit"></i></span>
                        </button>
                        
                        <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><i class="fa fa-times"></i></span>
                        </button>
                    </div>
                </div>

                <div class="modal-body help-modal">
                    <div class="ql-editor">
                        <div v-if="shownVideo" class="text-justify" v-html="text"></div>
                        <div v-else>
                            <div class="text-center" id="videoDiv" v-if="video">
                                <video controls id="videoTag" v-html="video"></video>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="resetVideo()">
                        {{ $t("buttons.close") }}
                    </button>
                </div>
            </div>
        </div>
        
        <EditHelpDialog v-if="isAdmin" ref="editHelpDialog"/>
    </div>
</template>

<script>
import { mapState, mapStores } from 'pinia';
import EditHelpDialog from "./EditHelpDialog";
import { useRootStore } from '../../stores/root';
import utils from '../../utils/utils';

export default {
    name: "HelpDialog",
    
    components: {
        EditHelpDialog
    },

    data() {
        return {
            language: utils.DEFAULT_LANGUAGE,
            languages: utils.LANGUAGES,
            text: "",
            video: "",
            shownVideo: true
        }
    },

    computed: {
        ...mapStores(useRootStore),
        ...mapState(useRootStore, ["isAdmin", "user"])
    },
    

    methods: {
        openEditHelpDialog() {
            this.rootStore.getPages(1)
                .then(pages => {
                    this.$refs.editHelpDialog.setParameters(1, pages, this.$route.name, this.language);
                });
            $(this.$refs.editHelpDialog.$el).modal();
            $(".help-modal").css("display", "none");
        },

        setTextVideo(text, video) {
            this.text = text || `<strong>${this.$t("dialogs.help.empty_text")}</strong>`;
            this.video = video;
        },

        resetVideo() {
            const video = $('#videoTag').get(0);
            video && video.load();
        },

        changeLanguage(lang) {
            if (this.language === lang) {
                return;
            }
            
            this.language = lang;
            
            $(".help-title").text(this.helpText);
            
            this.rootStore.getHelpText(this.user.role.id, this.$route.name, this.language)
                .then(response => {
                    this.setTextVideo(response["text"], response["video"]);
                    
                    if (!this.shownVideo && response["video"] == '') {
                        this.shownVideo = true;
                    }
                });
        },
        
        getLanguage() {
            return this.language;
        },
    },
}
</script>

<style scoped>
.confirm-dialog-help .modal-content {
    border: 0;
}

.confirm-dialog-help .modal-header h5 {
    margin: 0;
}

.confirm-dialog-help .modal-body {
    position: relative;
    min-height: 130px;
    height: auto;
    background-color: whitesmoke;
}

.modal-body .row {
    position: absolute;
    bottom: 1em;
    right: 1em;
    margin: 0;
    padding: 0;
}

.modal-body .row button {
    margin-left: 0.5em;
}

.pad-9 {
    padding: 0.9rem 0.9rem;
    outline: none;
}

.ml-m2 {
    margin-left: -0.2rem;
}

.ml-m6 {
    margin-left: -0.6rem;
}

.modal-body {
    word-wrap: break-word;
    background-color: white !important;
}

#videoTag {
    max-width: 100%;
}

.modal-header button {
    background: none;
    color: white;
    opacity: 0.5;
    border: none;
    transition: opacity 0.26s ease;
}
.modal-header button:hover {
    opacity: 1;
}
</style>
